import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';
import { disabledBehavior } from '../Shared/ButtonDisabledBehavior.styled';
import { overlayInteraction } from '../Shared/ButtonOverlay.styled';

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  color: ${({ theme }) => theme.color.assistantMessage};
  font-size: ${({ theme }) => theme.font.size.default};
  font-weight: ${({ theme }) => theme.font.weight.medium};

  svg {
    color: ${({ theme }) => theme.color.assistantMessage};
  }
    
  ${disabledBehavior()}

  ${overlayInteraction({isHighlighted: (theme) => !!(theme as IOcAppTheme).color.highlightOnChatBG})}
`;

export const ChevronIcon = styled.svg<{ $isExpanded: boolean }>`
  width: 12px;
  height: 12px;
  transform: ${({ $isExpanded }) => ($isExpanded ? 'rotate(90deg)' : 'rotate(0deg)')};
  transition: transform 0.2s;
`;

